const scheduledServicesUsersFilters = {
  usersFilters: "Filtros Usuários",
  searchUsers: "Buscar Usuários",
};

export default scheduledServicesUsersFilters;
